import { ReactNode } from 'react';
import { cn } from '../../utils';

type SectionHeaderProps = {
    title: string;
    subtitle?: string;
    children?: ReactNode;
    actions?: ReactNode;
};

export default function SectionHeader({
    title,
    subtitle,
    children,
    actions,
    ...rest
}: SectionHeaderProps) {
    return (
        <div
            className={cn('alli-relative alli-pb-5 sm:alli-pb-0', {
                'alli-border-b alli-border-gray-400': !children,
            })}
            {...rest}>
            <div className="alli-flex alli-items-center alli-justify-between">
                <h3 className="alli-text-base alli-font-semibold alli-leading-6 alli-text-gray-900">
                    {title}
                </h3>

                {actions && (
                    <div className="alli-mt-3 alli-flex alli-space-x-3">
                        {actions}
                    </div>
                )}
            </div>
            {subtitle && (
                <p className="-alli-mt-1 alli-mb-5 alli-truncate alli-text-sm alli-text-gray-700">
                    {subtitle}
                </p>
            )}

            {children && (
                <div className={cn({ 'alli-mt-10': !subtitle })}>
                    {children}
                </div>
            )}
        </div>
    );
}
